import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core'; 
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { interval, Observable, Subject, Subscription } from 'rxjs';
import * as moment from "moment"; 
import { FormatsUtil } from 'src/app/utils/formats.util';
import { UserService, CommonService, AlertService } from 'src/app/services';
import { delay, distinctUntilChanged, map, take, takeUntil } from "rxjs/operators";
import { environment } from 'src/environments/environment';
import { MsgConfig } from 'src/app/app.messages';
import { ReminderService } from 'src/app/services/reminder.service';
import { GroupedReminder } from 'src/app/models/reminder.model';
import { AccCategoryE, AccessToPrimeRxMarketE } from 'src/app/models';
import { PrivMaskGuard } from 'src/app/guards';
const drugImage = environment.DrugImage;

@Component({
  selector: 'reminders',
  templateUrl: './reminders.html',
  styleUrls: ['./reminders.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RemindersComponent implements OnInit, OnDestroy {
    badgeCount:any;
    bestPrice:any;
    inCartprice:any;
    regStatue: boolean = false;
    bestStatue: boolean = false;
    modelRef: any;
    @ViewChild("ISMARKETPLACE", { static: true })
    ISMARKETPLACE: any;
    @ViewChild("CUTOFFTIME", { static: true })
    CUTOFFTIME: any;
    @ViewChild("BESTDEAL", { static: true })
    BESTDEAL: any;
    @Output() oncrossBtnClick = new EventEmitter<any>();
    @Output() popupCompleted = new EventEmitter<void>();
    @Input() openSoozer:boolean;
    @Input() isCartBtn:boolean;
    @Input() IsPriceObj:any;
    @Input() IsRegUserpopup:boolean;
    @Input() frmDPV: boolean;
    bestPrinInfo:any;
    matchedNdcCount:any;
    cheapestEqCartCount:any;
    Qty: Number;
    unsubscribe$: Subject<void> = new Subject();
    reminders$: Observable<GroupedReminder[]>;
    imgURL = drugImage.replace("{imagefile}", "empty.jpg");
    openedVendorTimes = new Set<string>();
    dismissedTimes = new Set<string>();
    allKnownVendors = new Set<string>();
    remindersToShow = [];
    selectedGroup: GroupedReminder | null = null;
    selectedVendor = [];
    selectedSnooze: number = 5;
    isRegUserChecked: boolean = false;
    isCartActive:boolean = false;
    isCartLoading: boolean = false;
    cartPrivCheck:any;
    MPCmnCartTip:any;
    MPQtyByNDC:any;
    MPBestPrice:any;
    MPInCartPrice:any;
    cartCountData: any;
    timeWatcherSub: Subscription;
    showReminderPopup = false;
    noPrivMessage : string;
    isPopupOpen: boolean = false;
    isCountStatus:boolean = false;
    cleanedReminders: { time: string; vendors: string[]; RemindBefore: string[] }[] = [];
    selectedVendorsMap: { [time: string]: Set<string> } = {};
    firstVendorMap = new Map<string, string>();
    firstVendorSelectionMap = new Map<number, boolean>();
    selectedVendorMap: { [vendor: string]: boolean } = {};
    userHasSelected = false;
    constructor(
      private _modalService: NgbModal,
      private _formatsUtil: FormatsUtil,
      private _userServ: UserService,
      private _alertServ: AlertService,
      private _commonService: CommonService,
      private _privMaskGuard: PrivMaskGuard,
      private _reminderService:ReminderService,
      private _cdr: ChangeDetectorRef) {
      }

    ngOnInit(): void {
      this.noPrivMessage = MsgConfig.NO_PRIVS_ACCESS;
      this.badgeCount = 5;
      this.bestPrice = '--';
      this.inCartprice = '--';
      this.matchedNdcCount = '0';
      this.cheapestEqCartCount = '0';
      this._commonService._marketPriceInfo$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((frmNdrugIsPriceObj) => {
            if (frmNdrugIsPriceObj?.data?.length) {
                this.IsPriceObj = frmNdrugIsPriceObj;
                this.loadPriceInfoPopup();
                this._commonService._marketPriceInfo$.next(null);
            }
      });
      this.loadPriceInfoPopup();
      if(!this.isCartBtn)
          this.startTimeWatcher();
      this.cartPrivCheck = this._privMaskGuard.canActivate(AccCategoryE.AccessToPrimeRxMarket, AccessToPrimeRxMarketE.AddToCart);
      this._commonService._registrationStatus$
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((resp: any) => {
            this.isRegUserChecked = resp;
          });
    }

    loadPriceInfoPopup(): void{
      if (this.IsPriceObj && this.IsPriceObj?.data?.length) {
          const item = this.IsPriceObj?.data[0]; 
          this.isCartActive = item?.["best"]?.length > 0 || item?.["inCart"]?.length > 0 || item?.["cheapestEquiv"]?.length > 0;
          const cheapestEquiv_price = item?.["cheapestEquiv"]?.[0]?.price;
          const bestPrice = item?.["best"]?.[0]?.price;
          const best = bestPrice ? bestPrice : cheapestEquiv_price;
          const inCart = item?.["inCart"]?.[0]?.price;
          this.bestPrice =  best ?  '$'+ best : "--"; 
          this.inCartprice = inCart ? '$'+ inCart : "--";
          this.MPBestPrice = MsgConfig.MP_Best_Price.replace("{price}", this.bestPrice || '');
          this.MPInCartPrice = MsgConfig.MP_In_Cart_Price.replace("{price}", this.inCartprice || '');
          if (this.isCountStatus) return;
          this.isCountStatus = true;
          this.getCartCounts();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
      if (changes['IsRegUserpopup']?.currentValue === true) {
        this.goToMarketPlace();
      }
      const getPriceObj = changes['IsPriceObj']?.currentValue;
      if (getPriceObj) {
        this.loadPriceInfoPopup();
      }
    }

    selectVendor(group: GroupedReminder, vendor: string, groupIndex: string) {
      const timeKey = group.time;
      
      if (!this.selectedVendorsMap[timeKey]) {
          this.selectedVendorsMap[timeKey] = new Set();
      }
      
      if (this.selectedVendorsMap[timeKey].has(vendor)) {
          this.selectedVendorsMap[timeKey].delete(vendor);
          this.selectedVendor = [];
          this.selectedGroup = null;
      } else {
          this.selectedVendorsMap[timeKey].add(vendor);
          const vendorsSet = this.selectedVendorsMap[timeKey] || new Set();
          this.selectedVendor = Array.from(vendorsSet);
      } 
      this.selectedGroup = group;
    }

    isSelectedVendor(group: GroupedReminder, vendor: string, vendorIndex: number): boolean {
      const timeKey = group.time;
      if (!this.selectedVendorsMap[timeKey]) {
        this.selectedVendorsMap[timeKey] = new Set();
        if (vendorIndex === 0) {
          this.selectedVendorsMap[timeKey].add(vendor);
        }
      }
      if(this.selectedVendorsMap[timeKey].has(vendor)){
        const vendorsSet = this.selectedVendorsMap[timeKey] || new Set();
        this.selectedVendor = Array.from(vendorsSet);
        this.selectedGroup = group;
      }
      return this.selectedVendorsMap[timeKey].has(vendor);
    }

    onSnooze() {

        if (!this.selectedGroup || !this.selectedVendor || this.selectedVendor.length === 0) {
            this.tryAutoSelectFirstReminder();
            this._alertServ.error(MsgConfig.MP_Select_vendor);
            return;
        }
        let toastShown = false;
        const baseOffset = this.selectedGroup.RemindBefore?.[0];
        if (!baseOffset) {
            console.log("Invalid reminder offset.");
            return;
        }

        const [hrs, mins] = baseOffset.split(':').map(Number);
        const offsetMinutes = (hrs * 60) + mins;
        const vendors = Array.isArray(this.selectedVendor) ? this.selectedVendor : [this.selectedVendor];
        vendors?.forEach(vendor => {
            const updatedOffset = this._reminderService.snoozeReminder(
                this.selectedGroup,
                vendor,
                offsetMinutes,
                this.selectedSnooze
            );

            if (updatedOffset  && !toastShown) { 
              const hr = Math.floor(this.selectedSnooze / 60);
              const min = this.selectedSnooze % 60;
              const formatted = hr
                ? `In ${hr} hr${hr > 1 ? 's' : ''} ${min} min${min !== 1 ? 's' : ''}`
                : `In ${min} min${min !== 1 ? 's' : ''}`;
                this._alertServ.success(`Reminder will show ${formatted}`);
                toastShown = true;
            }
            this.selectedGroup.vendors = this.selectedGroup.vendors.filter(v => v !== vendor);
        });

        if (this.selectedGroup.vendors.length === 0) {
          this.closeModal();
          this.isPopupOpen = false;
          this.selectedGroup = null;
        } else {
          const firstVendor = this.selectedGroup.vendors[0];
          this.selectedVendor = [firstVendor];
          this.selectedVendorsMap[this.selectedGroup.time] = new Set([firstVendor]);
        }
    }

    onDismiss() {
        if (!this.selectedGroup || !this.selectedVendor || this.selectedVendor.length === 0) {
          this._alertServ.error(MsgConfig.MP_Select_vendor);
          return;
        }

        const vendorToDismiss = Array.isArray(this.selectedVendor) 
          ? this.selectedVendor[0] 
          : this.selectedVendor;

        this._reminderService.dismissVendor(this.selectedGroup, vendorToDismiss);

        const updatedGroups = this._reminderService.reminderSubject$.getValue(); 
        const updatedGroup = updatedGroups.find(g => g.time === this.selectedGroup.time);

        if (!updatedGroup) {
          this.closeModal();
          return;
        }
        
        if (updatedGroup.vendors.length === 0) {
          this.closeModal();
        } else {
          const firstVendor = updatedGroup.vendors[0];
          this.selectedVendor = [firstVendor];
          this.selectedGroup = updatedGroup;
          this.selectedVendorsMap[updatedGroup.time] = new Set([firstVendor]);
        }
        this.remindersToShow = updatedGroups.filter(g => g.time === this.selectedGroup?.time);
    }

    onDismissAll() {
        this._reminderService.dismissAll();
        this.closeModal();
    }

    tryAutoSelectFirstReminder(): void {
      if (!this.selectedGroup && (!this.selectedVendor || this.selectedVendor.length === 0) && this.remindersToShow?.length) {
        const firstGroup = this.remindersToShow[0];
        if (firstGroup?.vendors?.length) {
          this.selectedGroup = firstGroup;
          this.selectedVendor = [firstGroup.vendors[0]];
        }
      }
    }

    allowOnlyDigits(event: KeyboardEvent): void {
        const char = String.fromCharCode(event.which);
        if (!/^[0-9]$/.test(char)) {
          event.preventDefault();
        }
    }

    getQtyButtonText(item: any): string {
        const inputQty = parseInt(item.inputQty || '0', 10);
        const qtyAvl = parseInt(item.avalQtyByNdc || 0);
        if (qtyAvl === 0 || inputQty === 0) {
          return 'Add';
        } else if (inputQty !== qtyAvl) {
          return 'Update';
        } else {
          return 'In Cart';
        }
    }

    onQtyChange(item: any): string {
          const inputQtyStr = (item.inputQty || '').toString().replace(/\D/g, '');
          item.inputQty = inputQtyStr.slice(0, 4); 
          const inputQty = parseInt(item.inputQty || '0', 10);
          const qtyAvl = item.avalQtyByNdc || 0; 
          if (qtyAvl === 0 || inputQty === 0 || isNaN(inputQty)) { 
            return 'Add';
          } else if (inputQty !== qtyAvl) { 
            return 'Update';
          } else {
            return 'In Cart';
          }
    }

    preventPaste(event: ClipboardEvent): void {
        const pasted = event.clipboardData?.getData('text') || '';
        if (!/^\d{1,4}$/.test(pasted)) {
          event.preventDefault();
        }
    }

    startTimeWatcher() {
        this.openedVendorTimes = new Set<string>();
        this.remindersToShow = [];
        this.dismissedTimes = new Set<string>();
        this.allKnownVendors = new Set<string>();
        this.selectedVendorsMap = {};

        const minuteChange$ = interval(1000).pipe(
            map(() => moment()),
            distinctUntilChanged((a, b) => a.minute() === b.minute())
        );

        this.timeWatcherSub = minuteChange$.subscribe(now => {
            const nowHHMM = now.format('HH:mm');
            
            this._reminderService.reminder$.pipe(take(1)).subscribe(allReminders => {
                const currentTimeReminders = new Map<string, 
                    { vendors: string[], RemindBefore: string[] }>(); 
                // Keep existing reminders if popup is open
                if (this.isPopupOpen) {
                    this.remindersToShow.forEach(reminder => {
                        currentTimeReminders.set(reminder.time, {
                            vendors: [...reminder.vendors],
                            RemindBefore: [...reminder.RemindBefore]
                        });
                    });
                }
                // Process all current-time reminders
                allReminders.forEach(reminder => {
                    if (reminder.time === nowHHMM && !this.dismissedTimes.has(nowHHMM)) {
                        reminder.vendors.forEach(vendor => {
                            const vendorKey = `${reminder.time}|${vendor}`;
                            
                            if (!this.allKnownVendors.has(vendor)) {
                                this.allKnownVendors.add(vendor);
                                this.openedVendorTimes.add(vendorKey);
                                const existing = currentTimeReminders.get(reminder.time) || {
                                    vendors: [],
                                    RemindBefore: []
                                };
                                
                                if (!existing.vendors.includes(vendor)) {
                                    existing.vendors.push(vendor);
                                    existing.RemindBefore.push(...(reminder.RemindBefore || []));
                                    currentTimeReminders.set(reminder.time, existing);
                                }
                            }
                        });
                    }
                });
                // Update reminders list (only current time when popup is closed)
                this.remindersToShow = Array.from(currentTimeReminders.entries())
                    .filter(([time]) => this.isPopupOpen || time === nowHHMM)
                    .map(([time, data]) => ({
                        time,
                        vendors: data.vendors,
                        RemindBefore: [...new Set(data.RemindBefore)],
                        isSnoozedVal: null,
                        isDismissed: false
                    }));
                // Always open popup for current time matches (if not dismissed)
                const hasCurrentMatch = this.remindersToShow.some(r => r.time === nowHHMM);
                if (hasCurrentMatch && !this.isPopupOpen) {
                    this.isPopupOpen = true;
                    this.snooze();
                }
            });
        });
    }

    getRawMinutesUntil(reminderTime: string): number {
        const now = moment();
        const [hour, minute] = reminderTime.split(':').map(Number);
        let reminder = moment().startOf('day').add(hour, 'hours').add(minute, 'minutes');
        if (reminder.isBefore(now)) {
            reminder.add(1, 'day');
        }
        return reminder.diff(now, 'minutes');
    }

    getMinutesUntilFromOffset(offsetTime: string): string {
        const [hours, minutes] = offsetTime.split(':').map(Number);
        const totalMinutes = hours * 60 + minutes;
        const duration = moment.duration(totalMinutes, 'minutes');
        const hr = duration.hours();
        const min = duration.minutes();

        return hr
          ? `In ${hr} hr${hr > 1 ? 's' : ''} ${min} min${min !== 1 ? 's' : ''}`
          : `In ${min} min${min !== 1 ? 's' : ''}`;
    }

    calculateVendorTimeLeft(vendor: string): string {
        const now = moment(); 
        const matching = this._reminderService.reminderSubject$
          .getValue()
          .find(g => g.vendors.includes(vendor));

        if (matching && matching.ReminderTime) {
          const minsLeft = moment(matching.ReminderTime, 'HH:mm').diff(now, 'minutes');

          if (minsLeft <= 0) {
            return 'In 0 mins';
          } 
          const hr = Math.floor(minsLeft / 60);
          const min = minsLeft % 60;

          if (hr > 0) {
            if (min > 0) {
              return `In ${hr} hr${hr > 1 ? 's' : ''} ${min} min${min !== 1 ? 's' : ''}`;
            } else {
              return `In ${hr} hr${hr > 1 ? 's' : ''}`;
            }
          } 
          return `In ${min} min${min !== 1 ? 's' : ''}`;
        }

        return '';
    }


    snooze(){
        this.selectedVendor = [];
        if (this.remindersToShow.length) {
          const firstGroup = this.remindersToShow[0];
          if (firstGroup?.vendors?.length) {
            this.selectedGroup = firstGroup;
            this.selectedVendor = firstGroup.vendors[0];
          }
        }
        this.modelRef = this._modalService.open(this.CUTOFFTIME, {centered: true, backdrop: false, windowClass: "max-modal-27"});
    }

    goToMarketPlace(): void {
      this.modelRef = this._modalService.open(this.ISMARKETPLACE, {centered: true, backdrop: false, windowClass: "large--content"});
      this.popupCompleted.emit(); 
    }

    openCutOffNotificationPopup(){}

    goToBestDeal(){
      //this.modelRef = this._modalService.open(this.BESTDEAL, {centered: true, backdrop: false, windowClass: "max-wdth_73"}); 
    }

    getPriceInfo(){
        if(!this.isCartActive && this.isRegUserChecked) return;
        if(!this.isRegUserChecked){
          this.goToMarketPlace();
          return;
        }

        if(this.IsPriceObj && this.IsPriceObj?.data?.length) {  
              const item = this.IsPriceObj.data[0];
              const entries: any[] = [];
              const shippingInfo = item.shippingInfo && item.shippingInfo.length ? item.shippingInfo : {};
              const shippingInfoMapDefault = item.shippingInfo[0]?.default || {};
              const shippingInfoBrandMap = item.shippingInfo[0]?.brandSpecific || {};
              const shippingInfoMapImg = item.shippingInfo[0]?.shippingIcon || {};
              const mapEntry = (entry: any, label: string) => {
                  const supplierId = entry?.supplierId?.toString();
                  const shippingDetails = (entry?.isBrand && shippingInfoBrandMap[supplierId]) ? shippingInfoBrandMap[supplierId] : 
                  shippingInfoMapDefault[supplierId];
                  const isBrand = entry?.isBrand;
                  const brandIcon = isBrand ? "<span class='reminder-type'> Brand </span>" : "<span class='reminder-type'> Generic </span>";
                  return {
                      label,
                      DrugName: entry?.drugName || '',
                      Wholesaler: entry?.supplierName || '',
                      NDC: this._formatsUtil.getNDCFormat(entry?.cleanNdc) || '',
                      Pack_Size: (Number(entry?.packSize) || 0),
                      Qty_Avl: (Number(entry?.qtyAvl) || 0),
                      Pack_Price: entry?.price || '',
                      Expiry_Date: moment(entry?.expiryDate).isValid() ? moment(entry.expiryDate).format("MM/DD/YYYY") : '--',
                      brandIcon, 
                      imgURL: this.getDrugImageURL(entry?.drugImageFileName),
                      shippingInfo: shippingDetails,
                      shipImg: shippingInfoMapImg,
                      auctionId: entry?.auctionId || '',
                      manufacture: entry?.mfg || '',
                      creditTerm: entry?.creditTerm || '',
                      avalQtyByNdc: this.matchedQtyByNDC(this.cartCountData, entry?.cleanNdc,entry?.supplierName) || '',
                      inputQty: this.matchedQtyByNDC(this.cartCountData, entry?.cleanNdc,entry?.supplierName) || ''
                  };
              };

              const reservedKeys = ['ndc', 'ndcFound', 'shippingInfo'];
              const relevantKeys = Object.keys(item).filter(k => {
                return Array.isArray(item[k]) && item[k].length && typeof item[k][0] === 'object' && !reservedKeys.includes(k);
              });
              
              const orderedKeys = [
                  ...relevantKeys.filter(k => k === 'best'),
                  ...relevantKeys.filter(k => k === 'cheapestEquiv'),
                  ...relevantKeys.filter(k => k !== 'best' && k !== 'cheapestEquiv')
              ];
              for (const key of orderedKeys) {
                for (const obj of item[key]) {
                  const mappedEntry = mapEntry(obj, key);
                  mappedEntry.inputQty = mappedEntry.avalQtyByNdc;
                  entries.push(mapEntry(obj, key));
                }
              }
              this.bestPrinInfo = entries;
              this.modelRef = this._modalService.open(this.BESTDEAL, {
                  centered: true,
                  backdrop: false,
                  windowClass: this.frmDPV ? "max-wdth_73 bestDealPrompt_left" :  "max-wdth_73"
              });
            } else {
                  this.bestPrinInfo = [];
            }    
    }

    matchedQtyByNDC(cartCountData: any, reminderNDC: string,supplierName: string): number {
        const matched = cartCountData?.data?.find((c: any) => c.ndc?.replace(/-/g, '') === reminderNDC?.replace(/-/g, '') && c.source?.trim()?.toLowerCase() === supplierName?.trim()?.toLowerCase());
        return matched?.qty || 0;
    }

    getBrandIcons(item: any): string {
        return item?.DrugName.toUpperCase() + ' ' + item?.manufacture + ' &nbsp;&nbsp;|&nbsp;&nbsp; ' + item?.brandIcon;
    }

    getTagWithIcon(item: any): string {
        if (item?.label === 'best') {
          return `Best Priced (By NDC)`;
        } else if (item?.label === 'cheapestEquiv') {
          return `Best Priced (By Equivalent)`;
        } else if (item?.label === 'inCart') {
          return `Best Priced (In Cart)`;
        }
        return '';
    }

    getKeys(obj: any): string[] {
      return obj ? Object.keys(obj) : [];
    }
    
    async adddCardItems(item: any, qtyInput: any) {
      if(!this.cartPrivCheck) return;
      const npi = this._userServ.getToken("UniquePharmacyId");
      const inputQty = parseInt(item.inputQty || '0', 10);
      if(item.inputQty <= 0) {
          const msg = inputQty === 0
          ? MsgConfig.zero_not_valid
          : MsgConfig.ENTER_REQ_FIELD;
          this._alertServ.error(msg);
          item.inputQty = '';
          qtyInput.control.markAsTouched();
          return;
      }

      if(item.inputQty > item.Qty_Avl) {
          this._alertServ.error(`Cannot add more than available quantity (${item.Qty_Avl}).`);
          item.inputQty = '';
          qtyInput.control.markAsTouched();
          return;
      }
      
      const payload = {
        npi,
        addToCart: [
          {
            auctionId: item?.auctionId,
            quantity: item?.inputQty,
            price: item?.Pack_Price
          }
        ]
      };
      this.isCartLoading = true;
      await this._commonService.AddItemsToCart(payload)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((resp: any) => {
          if(resp?.status === "200" && resp?.itemsInCart){
            item.inputQty = '';
            this.matchedNdcCount = resp?.itemsInCart;
            this._alertServ.success(`Successfully added to the cart.`);
            this.getCartCounts();
          } else {
            this._alertServ.error(resp?.detail);
          }
        });
    }

    getDrugImageURL(fileName: string): string {
        if (fileName) {
            const parts = fileName.split(".");
            return drugImage.replace("{imagefile}", `${parts[0]}.${parts[1]}`);
        } else {
            return drugImage.replace("{imagefile}", "empty.jpg");
        }
    }

    async getCartCounts(){
        const item = this.IsPriceObj?.data?.[0];
        const npi = this._userServ.getToken("UniquePharmacyId");
        const matchedNdc = this.IsPriceObj?.data?.[0]?.ndc;
        const equivalentdNdc = this.IsPriceObj?.data?.[0]?.cheapestEquiv?.[0]?.cleanNdc;
        if (this.IsPriceObj?.data?.[0] != null) {
            const payload = { npi };
            await this._commonService.GetCartItems(payload).pipe(takeUntil(this.unsubscribe$)).subscribe((resp: any) => {
                if (resp?.status === "200") {
                    this.cartCountData = resp;
                    // Sum qty for matchedNdc
                    let matchedNdcCount = 0;
                    let equivalentdNdcCount = 0;
                    if (Array.isArray(resp?.data)) {
                        matchedNdcCount = resp.data
                            .filter((c: any) => c.ndc?.replace(/-/g, '') === matchedNdc?.replace(/-/g, ''))
                            .reduce((sum: number, c: any) => sum + (Number(c.qty) || 0), 0);
                        if (equivalentdNdc) {
                            equivalentdNdcCount = resp.data
                                .filter((c: any) => c.ndc?.replace(/-/g, '') === equivalentdNdc?.replace(/-/g, ''))
                                .reduce((sum: number, c: any) => sum + (Number(c.qty) || 0), 0);
                        }
                    }
                    this.matchedNdcCount = matchedNdcCount;
                    this.cheapestEqCartCount = equivalentdNdcCount;
                    if(this.isRegUserChecked){
                      this.MPQtyByNDC = MsgConfig.MP_Qty_ByNDC.replace("{NDC}", this._formatsUtil.getNDCFormat(matchedNdc) || '').replace("{count}", this.matchedNdcCount);
                      this.MPCmnCartTip = this.isCartActive ? this.MPQtyByNDC : MsgConfig.MP_Drug_nFound;
                    } else {
                      this.cartCountByNDCTooltip(matchedNdc);
                    }
                    this.isCartLoading = false;
                    this.refreshInputQtyFromCart();
                    this._cdr.detectChanges();
                    this.setFocus();
                } else {
                    this.cartCountByNDCTooltip(matchedNdc);
                    this.isCartLoading = false;
                }
            });
        } else if (this.IsPriceObj?.data[0] === null || 
                  (!item.best?.length && !item.cheapestEquiv?.length && !item.inCart?.length) ||
                  (!item.best?.length || !item.cheapestEquiv?.length || !item.inCart?.length)) {
            this.cartCountByNDCTooltip(matchedNdc);
            this.isCartLoading = false;
        }
    }

    cartCountByNDCTooltip(matchedNdc:any){
        if(this.isRegUserChecked){
            this.matchedNdcCount = 0;
            this.MPQtyByNDC = MsgConfig.MP_Qty_ByNDC.replace("{NDC}", this._formatsUtil.getNDCFormat(matchedNdc) || '').replace("{count}", this.matchedNdcCount);
            this.MPCmnCartTip = this.MPQtyByNDC;
        } else if(!this.isRegUserChecked){
            this.MPCmnCartTip = MsgConfig.MP_Drug_Pharmacy_Not_Reg;
        }
    }
    
    refreshInputQtyFromCart() {
        if (!this.bestPrinInfo?.length || !this.cartCountData?.data?.length) return;

        this.bestPrinInfo = this.bestPrinInfo.map(item => {
          const ndcMatch = this.cartCountData.data.find(
            (cartItem: any) => cartItem.ndc?.replace(/-/g, '') === item.NDC?.replace(/-/g, '') && cartItem?.source?.trim()?.toLowerCase() === item?.Wholesaler?.trim()?.toLowerCase()
          );
          const qty = ndcMatch?.qty?.toString() || '';
          return {
            ...item,
            avalQtyByNdc: qty,
            inputQty: qty
          };
        });
    }

    setFocus() {
        const btn = document.getElementById("remiderFocus");
        if (btn) {
          btn.focus();
        }
        const invalidInputs = document.getElementsByClassName("invalid-input");
        Array.from(invalidInputs).forEach((el: Element) => {
          const input = el as HTMLElement;
          input.classList.remove('invalid-input');
          input.classList.add('border-input');
        });
        event.preventDefault();
    }
    closeModal() {
        if (this.modelRef) {
            this.modelRef.close();
            this.modelRef = null;
        }
        this.isPopupOpen = false;
        this.allKnownVendors = new Set();
    }
    closeHoaPopUp() {
        if(this.modelRef) {
          this.modelRef.close();
          this.modelRef = null;
        } 
    }
    ngOnDestroy(): void {
        if (this.timeWatcherSub) {
          this.timeWatcherSub.unsubscribe();
        }
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        this._commonService._marketPriceInfo$.next(null);
    }

    async priceSearchByQty(event){
        const npi = this._userServ.getToken("UniquePharmacyId");
        const regStatue = this._commonService._registrationStatus$.value; 
        const tenantState= this._commonService._newTenatInfo$.value;
        this.Qty = event?.target?.value
        const payload = {
            "npi": npi,
            "state": tenantState?.PharmacyDetails?.StateName,
            "searchEq": regStatue?.registrationStatus ?? false,
            "searchNdc": {
                "ndc": this.IsPriceObj?.data?.[0]?.ndc
            }
        }
        await this._commonService.PriceSearch(payload).pipe(takeUntil(this.unsubscribe$)).subscribe((resp:any)=>{
            this.IsPriceObj = resp;
        })
    }

    getNavigationUrl() { 
      this._commonService.GetAutoLogin().pipe(takeUntil(this.unsubscribe$)).subscribe((resp:any) => {
          if (resp) {
            window.open(resp?.url, "_blank");
          }
          this.closeModal();
      });
    }
    onImgError(event: any) {
        event.target.src = 'assets/img/empty.jpg';
    }
}
